import { LeadFormWithId } from '@upright/ui/common/activities/lead-form/lead-form-with-id';
import { useQueryParams } from '../../generic/hooks/url-handling/query-params';
import { FormModal } from '../../generic/modals/form-modal';
import { emptyRequestDemoParams, getLeadForm, LeadFormId, leadFormParamKeys, LeadFormModalQueryParams } from './types';

export const LeadFormModal = () => {
  const [params, setParams] = useQueryParams<LeadFormModalQueryParams>(leadFormParamKeys);
  const id = params['lfid'];
  const isOpen = !!id;
  const form = id ? getLeadForm(id as LeadFormId) : undefined;
  return (
    <FormModal
      {...{
        isOpen,
        closeModal: () => {
          setParams(emptyRequestDemoParams);
        },
        accessibleName: form?.title || 'Request demo',
        // should be updated to lead-form but leaving there
        // for now to not accidently break e2e tests
        modalId: 'request-demo-modal',
        exit: 'down',
      }}
    >
      {id && <LeadFormWithId id={id as LeadFormId} inModal={true} />}
    </FormModal>
  );
};
